import React, { useEffect } from 'react';
import { Loader } from '@cloudclevr/components';
import useAuthStore from '@store/authStore';
import { UserRoles } from '@hooks/users/types';
import { useNavigate } from 'react-router-dom';
import useServicesStore from '@store/servicesStore';
import { isHelixDataVisible, isTraditionalCommsDataVisible } from '@utils/index';
import { useAuth } from '@auth';

type PrivateRouteProps = {
  children: JSX.Element;
  allowedRoles?: UserRoles[];
  isHelixPage?: boolean;
  isTraditionalCommsPage?: boolean;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  allowedRoles,
  isHelixPage = false,
  isTraditionalCommsPage = false
}) => {
  const authContext = useAuth();
  const navigate = useNavigate();
  const userRole = useAuthStore.getState().role || UserRoles.STANDARD;
  const { helixStatus, isFetched, traditionalCommsStatus } = useServicesStore();

  useEffect(() => {
    if (!authContext.isAuthenticated && authContext.isInitialized) {
      navigate('/unauthorized', { replace: true });
    } else if (
      (authContext.isAuthenticated &&
        allowedRoles &&
        !allowedRoles.includes(userRole)) || 
        (
          (isHelixPage && isFetched && !isHelixDataVisible(helixStatus)) 
          || (isTraditionalCommsPage && isFetched && !isTraditionalCommsDataVisible(traditionalCommsStatus))
        )
    ) {
      navigate('/unauthorized', { replace: true });
    }
  }, [authContext.isAuthenticated, authContext.isInitialized, userRole, allowedRoles,
      isHelixPage, isTraditionalCommsPage, helixStatus,
      traditionalCommsStatus, isFetched, navigate]);

  if (!authContext.isInitialized || !authContext.isAuthenticated) {
    return <Loader />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
